var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.selectDayEvent(_vm.index)}}},[_vm._t("default"),_c('b-progress',{staticStyle:{"margin-top":"5px"},attrs:{"rounded":true,"value":_vm.stats,"type":"is-success","size":"is-small"}})],2)}
var staticRenderFns = []

export { render, staticRenderFns }